import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=aeb949ba&scoped=true"
import script from "./Exception.vue?vue&type=script&lang=js"
export * from "./Exception.vue?vue&type=script&lang=js"
import style0 from "./Exception.vue?vue&type=style&index=0&id=aeb949ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb949ba",
  null
  
)

export default component.exports